import Icon from '../components/Icon.vue'

Icon.register({"bullseye":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 440C146.3 440 64 357.7 64 256 64 154.3 146.3 72 248 72 349.7 72 432 154.3 432 256 432 357.7 349.7 440 248 440zM248 128C177.3 128 120 185.3 120 256S177.3 384 248 384 376 326.7 376 256 318.7 128 248 128zM248 320C212.7 320 184 291.3 184 256S212.7 192 248 192 312 220.7 312 256 283.3 320 248 320z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bullseye.js
// module id = null
// module chunks = 